// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- 3rd Party
import moment from 'moment';

// --- HS Code
import {
  CommentsQuestion,
  CommentsQuestionPage,
  CommentsSection,
  EffectivenessViewModel,
  GroupResultModel,
  QuadrantModel,
  ResultsStatuses,
  SurveyResultModel,
  SurveyResultsModel,
  SurveySummaryModel,
  TrackMyJourneyResultsModel,
} from '../../../models';
import { CompareReportBaseService } from './compare-report-base.service';
import { SurveyBaseService } from '../survey/survey-base.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class CompareReportMockService extends CompareReportBaseService {


  constructor(_surveyService: SurveyBaseService) {
    super(_surveyService);
  }

  compareResults(primaryIdentifier: string, secondaryIdentifier: string): void {
    const results = this._getResults() as SurveyResultsModel;
    const surveys = this._campaigns();
    const primaryResults: TrackMyJourneyResultsModel = {
      scoreList: this._mapScores(results),
      survey: surveys.find(s => s.id === primaryIdentifier) || surveys[0],
      surveyResults: results,
    };
    const secondaryResults: TrackMyJourneyResultsModel = {
      scoreList: this._mapScores(results),
      survey: surveys.find(s => s.id === secondaryIdentifier) || surveys[1],
      surveyResults: results,
    };

    this._surveyResults$.next([
      primaryResults,
      secondaryResults,
    ]);
    this._areResultsLoading$.next(false);
  }
  loadCampaigns(identifier: string): void {
    const results = this._campaigns();
    this._campaignsLoading$.next(true);
    setTimeout(() => {
      this._campaignsLoading$.next(false);
      this._campaigns$.next(results);
    }, 3000);
  }

  private _getResults(): SurveyResultsModel {
    const results = {
      self: {
        humility: {
          quadrant: 1,
          heading: 'Category_Region_Heading_Humility',
          subHeading: 'Category_Region_Sub_Heading_Humility',
          index: 1,
          score: 0,
          indicators: [
            {
              categoryName: 'Question_Category_Authentic',
              categoryType: 1,
              index: 1,
              quadrant: 1,
              score: 24
            },
            {
              categoryName: 'Question_Category_Transforming',
              categoryType: 2,
              index: 2,
              quadrant: 1,
              score: 37
            },
            {
              categoryName: 'Question_Category_Reliable',
              categoryType: 3,
              index: 3,
              quadrant: 1,
              score: 25
            },
            {
              categoryName: 'Question_Category_Achieving',
              categoryType: 4,
              index: 4,
              quadrant: 1,
              score: 22
            }
          ]
        } as QuadrantModel,
        love: {
          quadrant: 2,
          heading: 'Category_Region_Heading_Love',
          subHeading: 'Category_Region_Sub_Heading_Love',
          index: 2,
          score: 0,
          indicators: [
            {
              categoryName: 'Question_Category_Encouraging',
              categoryType: 5,
              index: 2,
              quadrant: 2,
              score: 25
            },
            {
              categoryName: 'Question_Category_Relating',
              categoryType: 6,
              index: 1,
              quadrant: 2,
              score: 35
            },
            {
              categoryName: 'Question_Category_Compassionate',
              categoryType: 7,
              index: 4,
              quadrant: 2,
              score: 30
            },
            {
              categoryName: 'Question_Category_Developing',
              categoryType: 8,
              index: 3,
              quadrant: 2,
              score: 31
            }
          ]
        } as QuadrantModel,
        pride: {
          quadrant: 3,
          heading: 'Category_Region_Heading_Pride',
          subHeading: 'Category_Region_Sub_Heading_Pride',
          index: 3,
          score: 0,
          indicators: [
            {
              categoryName: 'Question_Category_Controlling',
              categoryType: 9,
              index: 3,
              quadrant: 3,
              score: 51
            },
            {
              categoryName: 'Question_Category_Competitive',
              categoryType: 10,
              index: 2,
              quadrant: 3,
              score: 51
            },
            {
              categoryName: 'Question_Category_Striving',
              categoryType: 11,
              index: 4,
              quadrant: 3,
              score: 53
            },
            {
              categoryName: 'Question_Category_Sarcastic',
              categoryType: 12,
              index: 1,
              quadrant: 3,
              score: 50
            }
          ]
        } as QuadrantModel,
        fear: {
          quadrant: 4,
          heading: 'Category_Region_Heading_Fear',
          subHeading: 'Category_Region_Sub_Heading_Fear',
          index: 4,
          score: 0,
          indicators: [
            {
              categoryName: 'Question_Category_Approval_Seeking',
              categoryType: 13,
              index: 1,
              quadrant: 4,
              score: 50
            },
            {
              categoryName: 'Question_Category_Avoiding',
              categoryType: 14,
              index: 4,
              quadrant: 4,
              score: 52
            },
            {
              categoryName: 'Question_Category_Easily_Offended',
              categoryType: 15,
              index: 2,
              quadrant: 4,
              score: 53
            },
            {
              categoryName: 'Question_Category_Dependent',
              categoryType: 16,
              index: 3,
              quadrant: 4,
              score: 50
            }
          ]
        }
      } as SurveyResultModel,
      benchmark: {
        humility: {
          quadrant: 1,
          heading: 'Category_Region_Heading_Humility',
          subHeading: 'Category_Region_Sub_Heading_Humility',
          index: 1,
          score: 0,
          indicators: [
            {
              categoryName: 'Question_Category_Authentic',
              categoryType: 1,
              index: 1,
              quadrant: 1,
              score: 24
            },
            {
              categoryName: 'Question_Category_Transforming',
              categoryType: 2,
              index: 2,
              quadrant: 1,
              score: 37
            },
            {
              categoryName: 'Question_Category_Reliable',
              categoryType: 3,
              index: 3,
              quadrant: 1,
              score: 25
            },
            {
              categoryName: 'Question_Category_Achieving',
              categoryType: 4,
              index: 4,
              quadrant: 1,
              score: 22
            }
          ]
        } as QuadrantModel,
        love: {
          quadrant: 2,
          heading: 'Category_Region_Heading_Love',
          subHeading: 'Category_Region_Sub_Heading_Love',
          index: 2,
          score: 0,
          indicators: [
            {
              categoryName: 'Question_Category_Encouraging',
              categoryType: 5,
              index: 2,
              quadrant: 2,
              score: 25
            },
            {
              categoryName: 'Question_Category_Relating',
              categoryType: 6,
              index: 1,
              quadrant: 2,
              score: 35
            },
            {
              categoryName: 'Question_Category_Compassionate',
              categoryType: 7,
              index: 4,
              quadrant: 2,
              score: 30
            },
            {
              categoryName: 'Question_Category_Developing',
              categoryType: 8,
              index: 3,
              quadrant: 2,
              score: 31
            }
          ]
        } as QuadrantModel,
        pride: {
          quadrant: 3,
          heading: 'Category_Region_Heading_Pride',
          subHeading: 'Category_Region_Sub_Heading_Pride',
          index: 3,
          score: 0,
          indicators: [
            {
              categoryName: 'Question_Category_Controlling',
              categoryType: 9,
              index: 3,
              quadrant: 3,
              score: 51
            },
            {
              categoryName: 'Question_Category_Competitive',
              categoryType: 10,
              index: 2,
              quadrant: 3,
              score: 51
            },
            {
              categoryName: 'Question_Category_Striving',
              categoryType: 11,
              index: 4,
              quadrant: 3,
              score: 53
            },
            {
              categoryName: 'Question_Category_Sarcastic',
              categoryType: 12,
              index: 1,
              quadrant: 3,
              score: 50
            }
          ]
        } as QuadrantModel,
        fear: {
          quadrant: 4,
          heading: 'Category_Region_Heading_Fear',
          subHeading: 'Category_Region_Sub_Heading_Fear',
          index: 4,
          score: 0,
          indicators: [
            {
              categoryName: 'Question_Category_Approval_Seeking',
              categoryType: 13,
              index: 1,
              quadrant: 4,
              score: 50
            },
            {
              categoryName: 'Question_Category_Avoiding',
              categoryType: 14,
              index: 4,
              quadrant: 4,
              score: 52
            },
            {
              categoryName: 'Question_Category_Easily_Offended',
              categoryType: 15,
              index: 2,
              quadrant: 4,
              score: 53
            },
            {
              categoryName: 'Question_Category_Dependent',
              categoryType: 16,
              index: 3,
              quadrant: 4,
              score: 50
            }
          ]
        } as QuadrantModel
      } as SurveyResultModel,
      others: null,
      commentsQuestionPages: [
        {
          pageNumberOffset: 0,
          pageNumber: 0,
          pageBlurb: '',
          sections: [
            {
              sectionName: 'Self',
              commentsQuestions: [
                {
                  questionTextResourceName: 'Individual_Feedback_Self_Stop',
                  questionResponses: [
                    ''
                  ]
                } as CommentsQuestion,
                {
                  questionTextResourceName: 'Individual_Feedback_Self_Start',
                  questionResponses: [
                    ''
                  ]
                } as CommentsQuestion,
                {
                  questionTextResourceName: 'Individual_Feedback_Self_Continue',
                  questionResponses: [
                    ''
                  ]
                } as CommentsQuestion
              ]
            } as CommentsSection
          ]
        } as CommentsQuestionPage
      ],
      groupResults: new Array<GroupResultModel>(),
      effectivenessModel: {} as EffectivenessViewModel,
      campaignEffectivenessModel: {} as EffectivenessViewModel,
      resultStatus: 30,
      resultsStatus: ResultsStatuses.resultsAvailable,
      reportReleaseDate: moment('2020-07-16T00:00:00').toDate(),
    };

    return results;
  }

  private _campaigns(): SurveySummaryModel[] {
    return [
      {
        id: '7f38d90f-36d6-4697-acd4-60681dfe34f9',
        moniker: 'HSC340358',
        participantName: '',
        name: 'My pack',
        organisationName: 'Sisters of Charity',
        type: 0,
        dateCreated: moment('2019-09-05T10:17:25.5607667').toDate(),
        dateOfClose: moment('2020-07-17T00:00:00').toDate(),
        dateOfReportRelease: moment('2020-07-16T00:00:00').toDate(),
        percentageComplete: 100,
        isDeleted: false,
        hasReport: false,
        status: 70,
        lockDate: moment('2020-09-05T00:00:00').toDate(),
        resultsStatus: ResultsStatuses.resultsAvailable,
        numberOfRespondents: 0,
        isLocked: false,
        numberOfOthers: 0,
        updated: moment().toDate(),
        campaignId: '90A96904-0A91-45B8-8CF4-C827999E17AF'
      },
      {
        id: '287c886f-74ba-49ba-a4f9-cdd7c3ece488',
        moniker: 'HSC330359',
        participantName: '',
        name: 'Resetrrrr',
        organisationName: 'Sample Organisation yurty',
        type: 0,
        dateCreated: moment('2019-07-19T10:14:49.8549262').toDate(),
        dateOfClose: moment('2019-07-29T00:00:00').toDate(),
        dateOfReportRelease: moment('2019-07-29T00:00:00').toDate(),
        percentageComplete: 100,
        isDeleted: false,
        hasReport: false,
        status: 70,
        lockDate: moment('2020-08-08T00:00:00').toDate(),
        resultsStatus: 30,
        numberOfRespondents: 3,
        isLocked: false,
        numberOfOthers: 3,
        updated: moment().toDate(),
        campaignId: '90A96904-0A91-45B8-8CF4-C827999E17AF'
      },
      {
        id: '8cd51527-6e2c-4094-8142-981f2e9818f4',
        moniker: 'HSC200054',
        participantName: '',
        name: 'Spanish Lat Test',
        organisationName: 'Demo Company',
        type: 0,
        dateCreated: moment('2017-02-27T18:42:10.9316564').toDate(),
        dateOfClose: moment('2019-09-01T00:00:00').toDate(),
        dateOfReportRelease: moment('2019-06-30T00:00:00').toDate(),
        percentageComplete: 23,
        isDeleted: false,
        hasReport: false,
        status: 30,
        lockDate: moment('2020-08-31T00:00:00').toDate(),
        resultsStatus: 0,
        numberOfRespondents: 15,
        isLocked: false,
        numberOfOthers: 15,
        updated: moment().toDate(),
        campaignId: '90A96904-0A91-45B8-8CF4-C827999E17AF'
      },
      {
        id: 'd81bfa6b-2fc4-41b7-ad36-2c5dd55e8068',
        moniker: 'HSC260338',
        participantName: '',
        name: 'testing 2405',
        organisationName: 'ACUMEN GLOBAL PARTNERS',
        type: 0,
        dateCreated: moment('2018-07-03T11:40:01.6820022').toDate(),
        dateOfClose: moment('2018-07-17T00:00:00').toDate(),
        dateOfReportRelease: moment('2018-07-24T00:00:00').toDate(),
        percentageComplete: 100,
        isDeleted: false,
        hasReport: true,
        status: 70,
        lockDate: moment('2020-08-06T00:00:00').toDate(),
        resultsStatus: 30,
        numberOfRespondents: 3,
        isLocked: false,
        numberOfOthers: 3,
        updated: moment().toDate(),
        campaignId: '90A96904-0A91-45B8-8CF4-C827999E17AF'
      },
      {
        id: '260ef850-173f-414c-a360-ce767904af7a',
        moniker: 'HSC230335',
        participantName: '',
        name: 'testing 24',
        organisationName: 'zzTESTING',
        type: 0,
        dateCreated: moment('2018-04-24T12:58:07.7412061').toDate(),
        dateOfClose: moment('2018-05-08T00:00:00').toDate(),
        dateOfReportRelease: moment('2018-05-15T00:00:00').toDate(),
        percentageComplete: 100,
        isDeleted: false,
        hasReport: true,
        status: 70,
        lockDate: moment('2020-08-07T00:00:00').toDate(),
        resultsStatus: 30,
        numberOfRespondents: 15,
        isLocked: false,
        numberOfOthers: 15,
        updated: moment().toDate(),
        campaignId: '90A96904-0A91-45B8-8CF4-C827999E17AF'
      },
      {
        id: '0c5108a4-e638-4ec7-9b75-85d814db35b9',
        moniker: 'HSC210332',
        participantName: '',
        name: 'ttttt',
        organisationName: 'Billing details Company',
        type: 0,
        dateCreated: moment('2018-02-15T12:55:49.7829511').toDate(),
        dateOfClose: moment('2018-03-01T00:00:00').toDate(),
        dateOfReportRelease: moment('2018-03-08T00:00:00').toDate(),
        percentageComplete: 100,
        isDeleted: false,
        hasReport: true,
        status: 70,
        lockDate: moment('2018-06-30T00:00:00').toDate(),
        resultsStatus: 30,
        numberOfRespondents: 15,
        isLocked: false,
        numberOfOthers: 15,
        updated: moment().toDate(),
        campaignId: '90A96904-0A91-45B8-8CF4-C827999E17AF'
      },
      {
        id: '540140e8-812d-4977-99e4-27b95f3e8c99',
        moniker: 'HSC200330',
        participantName: '',
        name: 'testing 1545t',
        organisationName: 'BAPTIST WORLD AID',
        type: 0,
        dateCreated: moment('2018-01-24T09:14:54.9381775').toDate(),
        dateOfClose: moment('2018-02-07T00:00:00').toDate(),
        dateOfReportRelease: moment('2018-02-14T00:00:00').toDate(),
        percentageComplete: 0,
        isDeleted: false,
        hasReport: false,
        status: 5,
        lockDate: moment('2018-05-07T00:00:00').toDate(),
        resultsStatus: 20,
        numberOfRespondents: 3,
        isLocked: false,
        numberOfOthers: 3,
        updated: moment().toDate(),
        campaignId: '90A96904-0A91-45B8-8CF4-C827999E17AF'
      },
      {
        id: 'a1f583dd-600a-4866-85aa-20021cd36116',
        moniker: 'HSC200331',
        participantName: '',
        name: 'testing 08ttt',
        organisationName: 'adhoc',
        type: 0,
        dateCreated: moment('2018-01-24T13:58:30.6839129').toDate(),
        dateOfClose: moment('2018-02-07T00:00:00').toDate(),
        dateOfReportRelease: moment('2018-02-14T00:00:00').toDate(),
        percentageComplete: 100,
        isDeleted: false,
        hasReport: true,
        status: 70,
        lockDate: moment('2020-08-06T00:00:00').toDate(),
        resultsStatus: 30,
        numberOfRespondents: 6,
        isLocked: false,
        numberOfOthers: 6,
        updated: moment().toDate(),
        campaignId: '90A96904-0A91-45B8-8CF4-C827999E17AF'
      },
      {
        id: '87e75967-389e-4c71-afbf-4e5f3ed92953',
        moniker: 'HSC200329',
        participantName: '',
        name: 'testing 08e44',
        organisationName: 'BAPTIST WORLD AID',
        type: 0,
        dateCreated: moment('2018-01-24T09:00:32.200736').toDate(),
        dateOfClose: moment('2018-02-07T00:00:00').toDate(),
        dateOfReportRelease: moment('2018-02-14T00:00:00').toDate(),
        percentageComplete: 100,
        isDeleted: false,
        hasReport: true,
        status: 70,
        lockDate: moment('2018-05-31T00:00:00').toDate(),
        resultsStatus: 30,
        numberOfRespondents: 6,
        isLocked: false,
        numberOfOthers: 6,
        updated: moment().toDate(),
        campaignId: '90A96904-0A91-45B8-8CF4-C827999E17AF'
      },
      {
        id: '5eba05b8-187b-46d0-b384-c70fc9d4b787',
        moniker: 'HSC200328',
        participantName: '',
        name: 'testing 08ddd',
        organisationName: 'BAPTIST WORLD AID',
        type: 0,
        dateCreated: moment('2018-01-23T14:19:46.1128425').toDate(),
        dateOfClose: moment('2018-02-06T00:00:00').toDate(),
        dateOfReportRelease: moment('2018-02-13T00:00:00').toDate(),
        percentageComplete: 0,
        isDeleted: false,
        hasReport: false,
        status: 5,
        lockDate: moment('2018-05-06T00:00:00').toDate(),
        resultsStatus: 20,
        numberOfRespondents: 0,
        isLocked: false,
        numberOfOthers: 0,
        updated: moment().toDate(),
        campaignId: '90A96904-0A91-45B8-8CF4-C827999E17AF'
      },
      {
        id: '3b040a0c-4349-47bf-ad7c-ccc6cf6726b1',
        moniker: 'HSC200324',
        participantName: '',
        name: 'testingrtttttt4',
        organisationName: 'Adshel(New system)',
        type: 0,
        dateCreated: moment('2018-01-22T08:53:01.2877894').toDate(),
        dateOfClose: moment('2018-02-05T00:00:00').toDate(),
        dateOfReportRelease: moment('2018-02-12T00:00:00').toDate(),
        percentageComplete: 0,
        isDeleted: false,
        hasReport: false,
        status: 5,
        lockDate: moment('2018-05-05T00:00:00').toDate(),
        resultsStatus: 0,
        numberOfRespondents: 3,
        isLocked: false,
        numberOfOthers: 3,
        updated: moment().toDate(),
        campaignId: '90A96904-0A91-45B8-8CF4-C827999E17AF'
      },
      {
        id: 'a7425fac-f73d-47ad-b353-863c683d0363',
        moniker: 'HSC200313',
        participantName: '',
        name: 'Undercover',
        organisationName: 'baby',
        type: 0,
        dateCreated: moment('2017-11-28T08:20:33.3118208').toDate(),
        dateOfClose: moment('2017-12-12T00:00:00').toDate(),
        dateOfReportRelease: moment('2017-12-19T00:00:00').toDate(),
        percentageComplete: 0,
        isDeleted: false,
        hasReport: false,
        status: 10,
        lockDate: moment('2018-03-12T00:00:00').toDate(),
        resultsStatus: 20,
        numberOfRespondents: 3,
        isLocked: false,
        numberOfOthers: 3,
        updated: moment().toDate(),
        campaignId: 'B7A89BC7-D744-43A7-AE3F-D93F26B5FA8C'
      },
      {
        id: 'cc9a0398-0e76-4cc6-b7e5-5f39bd5a81e0',
        moniker: 'HSC200248',
        participantName: '',
        name: 'Portuguese Beta Test',
        organisationName: 'YUM! BRANDS',
        type: 0,
        dateCreated: moment('2017-09-13T09:41:01.7817086').toDate(),
        dateOfClose: moment('2017-10-17T00:00:00').toDate(),
        dateOfReportRelease: moment('2017-10-20T00:00:00').toDate(),
        percentageComplete: 0,
        isDeleted: false,
        hasReport: false,
        status: 30,
        lockDate: moment('2018-05-24T00:00:00').toDate(),
        resultsStatus: 20,
        numberOfRespondents: 0,
        isLocked: false,
        numberOfOthers: 0,
        updated: moment().toDate(),
        campaignId: 'B7A89BC7-D744-43A7-AE3F-D93F26B5FA8C'
      },
      {
        id: '7b226d6c-0178-4887-a471-747a7fe76eb0',
        moniker: 'HSC200236',
        participantName: '',
        name: 'name memory',
        organisationName: 'test selenium',
        type: 0,
        dateCreated: moment('2017-09-05T13:09:28.35638').toDate(),
        dateOfClose: moment('2017-09-19T00:00:00').toDate(),
        dateOfReportRelease: moment('2017-09-26T00:00:00').toDate(),
        percentageComplete: 100,
        isDeleted: false,
        hasReport: true,
        status: 70,
        lockDate: moment('2018-11-30T00:00:00').toDate(),
        resultsStatus: 30,
        numberOfRespondents: 15,
        isLocked: false,
        numberOfOthers: 15,
        updated: moment().toDate(),
        campaignId: 'B7A89BC7-D744-43A7-AE3F-D93F26B5FA8C'
      },
      {
        id: '8fec748e-43eb-4439-b151-d4bba856f52d',
        moniker: 'HSC200179',
        participantName: '',
        name: 'trrr',
        organisationName: 'Admin Retest',
        type: 0,
        dateCreated: moment('2017-07-20T12:24:29.4733478').toDate(),
        dateOfClose: moment('2017-08-03T00:00:00').toDate(),
        dateOfReportRelease: moment('2017-08-10T00:00:00').toDate(),
        percentageComplete: 10,
        isDeleted: false,
        hasReport: false,
        status: 30,
        lockDate: moment('2020-08-06T00:00:00').toDate(),
        resultsStatus: 0,
        numberOfRespondents: 3,
        isLocked: false,
        numberOfOthers: 3,
        updated: moment().toDate(),
        campaignId: 'B7A89BC7-D744-43A7-AE3F-D93F26B5FA8C'
      },
      {
        id: '13fbc5ce-744a-4397-99ef-602146ac64bb',
        moniker: 'HSC200071',
        participantName: '',
        name: 'MyPack Test',
        organisationName: 'zzTEST CHILD ORG',
        type: 0,
        dateCreated: moment('2017-03-16T15:53:25.1118356').toDate(),
        dateOfClose: moment('2017-03-17T00:00:00').toDate(),
        dateOfReportRelease: moment('2017-03-17T00:00:00').toDate(),
        percentageComplete: 0,
        isDeleted: false,
        hasReport: false,
        status: 25,
        lockDate: moment('2017-06-30T00:00:00').toDate(),
        resultsStatus: 20,
        numberOfRespondents: 6,
        isLocked: false,
        numberOfOthers: 6,
        updated: moment().toDate(),
        campaignId: 'B7A89BC7-D744-43A7-AE3F-D93F26B5FA8C'
      }
    ]
  }
}
